const termTypes = {
  ceramic: 'ceramic',
  foil: 'foil',
  o2sensor: 'o2sensor',
  diesel: 'diesel',
};

export { termTypes };
